











import { pagination } from '@/libs/util';
import DictMixin from '@/mixins/dict-mixin';
import RoleServices from '@/services/role';
import { mixins } from 'vue-class-component';
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class AddUser extends mixins(DictMixin) {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  pagination = pagination;

  roleSrv = new RoleServices();

  columns = [
    { title: '角色名称', dataIndex: 'roleName' },
    { title: '部门名称', dataIndex: 'roleRefDept' },
    { title: '角色描述', dataIndex: 'roleDescription' }
  ];

  dataSource: any = [];

  selectedRows: any[] = [];
  onSelectChange(keys: any, rows: any) {
    this.selectedRows = rows;
  }

  @Watch('visible')
  async onVisibleChange() {
    if (!this.syncVisible) return false;
    let res = await this.roleSrv.getList({ roleKind_eq: '0' });
    this.dataSource = res;
  }

  async confirm() {
    this.$emit('success', this.selectedRows);
    this.syncVisible = false;
  }
}
